import useDataLayerEvent from 'js/components/DataLayer/hooks/useDataLayerEvent';

function useOnClick(dataLayer, handler) {
  return useDataLayerEvent(dataLayer, 'click', handler);
}

export default useOnClick;
